import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'createby', 'dibayarke', 'kodeacc', 'namaacc', 'isProject', 'crewkey', 'crewname', 'jenisAdv','jenisSettlOS','statuswf'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/advance${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listpaid(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'nomorPaym', 'kodeacc', 'crewinfo', 'crewkey', 'matauang', 'isProject'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/advanpaym${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    outstand(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'DimValCode', 'tgl1', 'tgl2', 'outstand', 'nomor', 'nomorPaym', 'kodeacc', 'crewinfo', 'crewkey', 'matauang', 'jenisAdv'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/advanpaym/outstand${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    outstandexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'DimValCode', 'tgl1', 'tgl2', 'outstand', 'nomor', 'nomorPaym', 'kodeacc', 'crewinfo', 'crewkey', 'matauang', 'jenisAdv'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/advanpaym/outstandexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'advance_outstanding.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                });
                resolve();
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    advancegroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/advance/advancegroup");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`advance/detail/${obj.advanKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    budgetprogressdtlsmry(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/budgetinternal/progressdtlsmry/${obj.ibudgdtkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    budgetline(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/budgetinternal/detail/${obj.ibudghdkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },

    update(dataObj) {
        return new Promise(async (resolve, reject) => {
            try {
                const obj = {
                    DimColName: dataObj.DimColName,
                    DimColDesc: dataObj.DimColDesc,
                    Caption: dataObj.Caption,
                    FilterCap: dataObj.FilterCap,
                    DimSequence: dataObj.DimSequence,
                    isUsed: dataObj.isUsed
                };
                await axios.put(`advance/${data.idrowunik}`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    insert(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("advance", obj);
                resolve(data);
    
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`advance/${obj.advanKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('File Name : ', formData.filename);
                const { data } = await axios.post("advance/send2wf", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/advance/send2wfCancel/${obj.advanKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.advanKey);
                url = `/advance/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printpb(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.advanKey);
                url = `/advance/printpb`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    printpbmultiple(arrInv) {
        return new Promise(async (resolve, reject) => {
            try {                
                const { data } = await axios.get(`/advance/printpbmultiple?arrInv=${encodeURIComponent(JSON.stringify(arrInv))}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    

    exportxls(obj = {}) {
        const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'createby', 'dibayarke', 'kodeacc', 'namaacc', 'crewkey', 'crewname', 'final'];
        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/advance/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'advance.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    submit(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`advance/send2wf/${obj.advanKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    submitCancel(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`advance/send2wfCancel/${obj.advanKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    attachmentDownload(obj){
        return new Promise((resolve, reject) => {
            try {
                axios({
                    url: `tasktodo/attachment/${obj.attachmentKey}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', obj.attchFileNm);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }

};